import iconFile from '../../assets/images/icon_tool.gif';
import { ItemToolSubTypes } from '../../lib/ItemUtil';
import TopBase, { type TopBaseProps } from '../lib/TopBase';

class ToolTop extends TopBase {
    constructor(props: TopBaseProps) {
        super(props);
        this.type = 'tool';
        this.label = 'Tool';
        this.icon = iconFile;
        this.description =
            '[en]Tools for non-specific models or data.[/en][ja]特定のモデルやデータに限定しない汎用ツール[/ja]';
        this.subTypes = ItemToolSubTypes;
    }
}

export default ToolTop;
